import { render, staticRenderFns } from "./AdminPerformance.vue?vue&type=template&id=14252d9c&"
import script from "./AdminPerformance.vue?vue&type=script&lang=js&"
export * from "./AdminPerformance.vue?vue&type=script&lang=js&"
import style0 from "./AdminPerformance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports